<div class="metadata d-flex flex-column">
  <div class="color-basic-800 fw-700 fs-m pb-2">{{'document.associated-to.title' | translate}}</div>

  <!--Doc admin only-->
  @if (documentType === 'admin_doc') {
    <div *ngIf="documentType === 'admin_doc'" class="displayed-publication-type">
      @if (displayedPublicationType === DisplayedPublicationType.NON_DETECTED) {
        <i class="ph-fill ph-file-text me-1"></i>
        <span class="color-basic-600" [style.font-style]="'italic'">{{ displayedPublicationType }}</span>
      }
      @if (displayedPublicationType !== DisplayedPublicationType.NON_DETECTED) {
        <i class="ph-fill ph-file me-1"></i>
        <span class="fw-bold">{{ 'document.issuer-kind.' + issuerKind | translate }}</span>
        <span class="px-1">-</span>
        <span>{{ displayedPublicationType && (displayedPublicationType | translate) }}</span>
      }
    </div>
  }

  <div class="publication-date">
    <i class="ph-fill ph-calendar-check me-1"></i>
    @if (!publicationDate) {
      <span>{{'content.date_not_detected' | translate}}</span>
    } @else {
      <ng-container *ngTemplateOutlet="publicationDateDisplay"></ng-container>
    }
  </div>

  @if (territories?.length) {
    <div class="d-flex">
      <i class="ph-fill ph-map-pin me-1"></i>
      @if (territoryNames?.length) {
        <span class="territory-names">
          <div #territoryNamesContainer class="territory-names-container truncate-text"
               overflowTooltip
               ngbTooltip="{{territoryNames?.join(', ')}}"
               placement="bottom left"
               tooltipClass="territory-names-tooltip">
            <span>
              {{ territoryNames?.join(', ') }}
            </span>
         </div>
      </span>
      }
    </div>
  }

  @if (source) {
    <div class="source">
      <i class="ph-fill ph-newspaper me-1"></i>
      <span>{{ source }}</span>
    </div>
  }

  @if (!associatedEntitiesTemplate && website) {
    <div class="website">
      <i class="ph ph-link-simple me-1"></i>
      <span>{{ website }}</span>
    </div>
  } @else if (associatedEntitiesTemplate) {
    <ng-container *ngTemplateOutlet="associatedEntitiesTemplate"></ng-container>
  }
</div>

<ng-template #publicationDateDisplay>
    <span *ngIf="source">{{publicationDate | date: 'dd MMMM yyyy':'':'fr'}}</span>
    <span *ngIf="website">{{publicationDate | date: 'dd MMMM yyyy':'':'fr' | titlecase}}</span>
</ng-template>
